// import { Mail01 } from "@untitledui/icons"; // TODO: Re-enable when leadingIcon is supported
import { Input, type InputProps } from "@/components/base/input/input";
import { useFieldContext } from "..";
import { FieldErrors } from "./FieldErrors";

interface EmailFieldProps
	extends Omit<InputProps, "value" | "onChange" | "onBlur" | "name" | "type"> {
	label?: string;
	field?: any; // Simplified for now - will be properly typed later
}

const EmailField = ({
	label = "Email",
	field: fieldProp,
	...props
}: EmailFieldProps) => {
	// Support both patterns:
	// 1. form.Field with explicit field prop
	// 2. form.AppField with useFieldContext
	const contextField = useFieldContext<string>();
	const field = fieldProp || contextField;

	return (
		<div className="space-y-2">
			<Input
				{...props}
				type="email"
				id={field.name}
				name={field.name}
				label={label}
				value={field.state.value}
				onChange={(e) => field.handleChange((e as any).target?.value || e)}
				onBlur={field.handleBlur}
				isInvalid={field.state.meta.isTouched && !field.state.meta.isValid}
				isDisabled={props.isDisabled || field.state.meta.isValidating}
				isRequired={props.isRequired || field.state.meta.isRequired}
				// leadingIcon={Mail01} // TODO: Fix this prop
				placeholder={props.placeholder || "olivia@untitledui.com"}
			/>
			<FieldErrors meta={field.state.meta} />
		</div>
	);
};

export default EmailField;
